import { api ,getBlob} from "../../services/NetworkBase";
import { saveAs } from "file-saver";

export async function GetUserRoutes() {
  try {
    let response = await api.get(`vlp/user-routes`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetWaterProfilesByCriteria(startDate,endDate,isActive,searchText) {	
	try {
		let response = await api
		.get(`vlp/client-water-profiles?startDate=${startDate}&endDate=${endDate}&isActive=${isActive}&searchText=${searchText}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function GetWaterProfileById(profileId) {
  try {
    let response = await api.get(`vlp/client-water-profiles/${profileId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetNextTypeForClient(accountNumber) {
  try {
    let response = await api.get(`vlp/client-water-profiles/next-type/${accountNumber}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}
//CheckTypeAvailability

export async function CheckTypeAvailability(dto) {  
  try {
    let response = await api.post("vlp/client-water-profiles/name-availability", { json: dto });
    
    return response.json();
  } catch (error) {
    throw error;
  }
}

export async function UpdateWaterProfile(route) {  
  try {
    let response = await api.put("vlp/client-water-profiles", { json: route });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveWaterProfile(route) {
  try {
    let response = await api.post("vlp/client-water-profiles", { json: route });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteWaterProfile(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .delete(`vlp/client-water-profiles/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function AlterActiveState(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .put(`vlp/client-water-profiles/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PrintUserRouteCoC(clients) {
  const encodedClients = encodeURIComponent(clients);
  let blob = await getBlob(`vlp/user-routes/coc/${clients}`);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  saveAs(blob, `Consolidated_Pool_CoC.pdf`);
}


export async function PrintUserRouteDoc(routeId) {
  let blob = await getBlob(`vlp/user-routes/pickup-doc/${routeId}`);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  saveAs(blob, `${routeId}.pdf`);
}


export async function DuplicateWaterProfile(routeId,selectedRoute) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .put(`vlp/client-water-profiles/${encodedUrl}/duplicate`, { json: selectedRoute })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
